const colors = {
  brandBlue: "#4a90e2",
  brandLightBlue: "#c8ebf2",
  brandLightGreen: "#c1efe0",
  statesErrorTertiary: "#F9E1E6",
  brandLightYellow: "#fffedc",
  yellow: "#764400",
  green: "#092215",
  statesSuccessTertiary40: "rgba(193, 239, 201, 0.4)",
  gray05: "rgba(0, 0, 0, 0.05)",
  gray30: "rgba(0, 0, 0, 0.3)",
}
export default colors
